module.exports = __webpack_public_path__ + "img/zimbabwe-logo-icon.967cb83c.png";